import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import Spinner from "../Spinner";

const ButtonExport = ({ text, loading, forced, icon, ...props }) => (
  <Button
    style={{
      position: "relative",
      alignItems: "center",
      display: "flex",
      gap: 5,
      justifyContent: "center",
      color: "#707070",
      backgroundColor: "#ffffff",
      borderColor: "#C7C7C7",
      fontSize: 14,
      height: 38,
    }}
    {...props}
    disabled={loading === true || forced === true || props.disabled}
  >
    <div style={{ width: 20, marginTop: -4 }}>
      <Spinner loading={loading} />
      {!loading ? icon : null}
    </div>

    <p className="p-0 m-0 text-body">{text}</p>
  </Button>
);

ButtonExport.propTypes = {
  text: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  icon: PropTypes.any,
};

export default ButtonExport;



// WEBPACK FOOTER //
// ./src/components/common/ButtonExport/ButtonExport.jsx